const SET_DEVICE = 'DEVICE/SET_DEVICE'
// TODO: add more action types if necessary

export {
  SET_DEVICE,
  // TODO: export action types added later
}
